import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import featureFlagsSaga from './featureFlags/saga';
import forgotPasswordSaga from './forgotPassword/saga';
import i18nSaga from './i18n/saga';
import loginSaga from './login/saga';
import miscSaga from './saga-mess';
import notificationSaga from './notifications/saga';
import openPlatformSaga from './openPlatform/saga';
import resetGoBizPasswordSaga from './resetGoBizPassword/saga';
import verifyEmailSaga from './verifyEmail/saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    featureFlagsSaga(),
    forgotPasswordSaga(),
    i18nSaga(),
    loginSaga(),
    miscSaga(),
    notificationSaga(),
    openPlatformSaga(),
    resetGoBizPasswordSaga(),
    verifyEmailSaga(),
  ]);
}
